import React, { useEffect, useState } from "react";

import GroupedBarChart from "../../../../CHARTS/GroupedBarChart";
import { getDaysInFYMonths, months } from "../../../../Utilitie";
import { MdChangeCircle } from "react-icons/md";
const NKJFlowChart = ({ data }) => {
  const [chartData, setChartData] = useState(null);
  const [perDay, setPerDay] = useState(true);
  const product = ["total"];

  useEffect(() => {
    let years = [...new Set(data.map((o) => o.f_year))];
    years.sort((a, b) => a.replace("-", "") - b.replace("-", ""));
    let tempChart = {
      dimensions: ["product", ...years],
      series: [],
    };

    product.map((p) => {
      let obj = { product: p.toUpperCase() };

      years.forEach((year) => {
        let tempMonths = [
          ...new Set(
            data
              .filter((o) => o.f_year === year)
              .map((o) => o.a_month?.toUpperCase().slice(0, 3)),
          ),
        ];
        let month = tempMonths.sort(
          (a, b) => months.indexOf(a) - months.indexOf(b),
        );

        let days = month ? getDaysInFYMonths(year.replace("-", "_"), month) : 1;
        const total = data.reduce((sum, o) => {
          if (o.f_year === year) {
            return sum + (o[p] / (perDay ? days : 1) || 0); // safely add
          }
          return sum; // must return sum if condition fails
        }, 0);

        obj[year] = total.toFixed(2);
      });

      tempChart.series.push(obj);
    });

    setChartData(tempChart);
  }, [data, perDay]);

  return (
    <div className="newUiBody">
      <h5 className="glassHeading">
        AVG
        <b style={{ fontSize: "13px", color: "rgb(51, 46, 46)" }}>
          {" "}
          ({perDay ? "per day" : "Total"}){" "}
        </b>{" "}
        <button
          className="btn btn-sm btn-outline-dark"
          onClick={() => setPerDay(!perDay)}
        >
          <MdChangeCircle />
        </button>
      </h5>
      {chartData && (
        <GroupedBarChart
          data={chartData}
          rotateText={0}
          from={`Block_C`}
          decimal={2}
          chartType="bar"
        />
      )}{" "}
    </div>
  );
};
export default NKJFlowChart;
